import { Injectable } from '@angular/core';
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AlertNotificationService {
  constructor(private translateServ: TranslateService) { }

  toast({
    title,
    subtitle = '',
    type = 'success',
    timer = 3000, // Default timer value
    closeable = true, // Default closeable value
    options = {},
  }: {
    title: string;
    subtitle?: string;
    type?: 'success' | 'error' | 'warning' | 'info' | 'question';
    timer?: number; // Optional timer value
    closeable?: boolean; // Optional closeable value
    options?: SweetAlertOptions;
  }) {
    return Swal.fire({
      toast: true,
      position: 'top-end',
      showConfirmButton: !closeable, // Show close button if not closeable
      timer: closeable ? timer : undefined, // Apply timer only if closeable is true
      timerProgressBar: closeable,
      title,
      text: subtitle,
      customClass: {
        container: 'custom-swal-container',
        popup: 'custom-swal-popup',
        title: 'swal-custom-class',
        htmlContainer: 'swal-html-container',
      },
      icon: type,
      ...options,
    });
  }

  confirm({
    title,
    text,
    type = 'success',
    options = {},
  }: {
    text?: string;
    title: string;
    type?: 'success' | 'error' | 'warning' | 'info' | 'question';
    options?: SweetAlertOptions;
  }) {
    return Swal.fire({
      title: this.translateServ.instant(title) ?? title,
      text: text ? this.translateServ.instant(text) ?? text : '',
      showCancelButton: true,
      confirmButtonText: this.translateServ.instant('ok'),
      cancelButtonText: this.translateServ.instant('cancel'),
      cancelButtonColor: '#c72951 !important',
      customClass: {
        container: 'custom-swal-container',
        popup: 'custom-swal-popup',
        cancelButton: 'Custom_Cancel', // Assuming you want this for error type
      },
      icon: type,
      ...options,
    });
  }

  alert({
    title,
    text = '',
    type = 'success',
    options = {},
  }: {
    title: string;
    text?: string;
    type?: 'success' | 'error' | 'warning' | 'info' | 'question';
    options?: SweetAlertOptions;
  }) {
    return Swal.fire({
      title,
      text,
      showCancelButton: false,
      confirmButtonText: this.translateServ.instant('cancel'),
      customClass: {
        container: 'custom-swal-container',
        popup: 'custom-swal-popup',
      },
      icon: type,
      ...options,
    });
  }
}
